import React, { useContext, useEffect } from 'react';
import { LocaleContext, RefsContext } from '@qover/contexts';
import { useForm } from '@qover/hooks';

export function UpdateDraftLanguageAndCountry() {
  const { language } = useContext(LocaleContext);
  const { country } = useContext(RefsContext);
  const form = useForm();

  function update() {
    form.batch(() => {
      form.change('settings.language', language);
      form.change('refs.country', country);
    });
  }

  useEffect(() => {
    update();
  }, []);

  useEffect(() => {
    update();
  }, [language, country]);

  return null;
}
